
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20.704","height":"20.704"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 2134","d":"M15.528 13.661a1.282 1.282 0 010 1.867 1.282 1.282 0 01-1.867 0l-3.309-3.31-3.288 3.289a1.332 1.332 0 01-.944.414 1.34 1.34 0 01-1.336-1.337 1.332 1.332 0 01.413-.944l3.288-3.288-3.309-3.31a1.282 1.282 0 010-1.866 1.282 1.282 0 011.867 0l3.309 3.31 3.31-3.31a1.282 1.282 0 011.866 0 1.282 1.282 0 010 1.867l-3.31 3.309z","fill":"#4b536b"}})])
          )
        }
      }
    